import { cn } from "@/lib/utils";
import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";

/** Full-cell click target (copied from RawData CellHitArea) for copy / future edit. */
export const AdminCellHitArea = forwardRef<
    HTMLButtonElement,
    {
        align?: "start" | "center";
        className?: string;
    } & ButtonHTMLAttributes<HTMLButtonElement>
>(function AdminCellHitArea({ align = "start", className, children, ...props }, ref) {
    return (
        <button
            ref={ref}
            type="button"
            className={cn(
                "group flex items-center px-2 py-1 rounded-sm w-full min-h-8 overflow-hidden transition-colors",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-300 focus-visible:ring-offset-0",
                align === "center" ? "justify-center" : "justify-start text-left",
                className
            )}
            {...props}
        >
            {children}
        </button>
    );
});

/** Number / icon chrome that reacts to AdminCellHitArea group-hover. */
export function AdminCellHoverContent({ children, className }: { children: ReactNode; className?: string }) {
    return (
        <span
            className={cn(
                "inline-flex justify-center items-center rounded-md transition-colors",
                "group-hover:bg-muted/70 group-focus-visible:bg-muted/70",
                className
            )}
        >
            {children}
        </span>
    );
}
